
  <div *ngIf="on">
    <hr>
    <textarea #dt [value]="text" rows="10" cols="80"></textarea>
    <br/>
    <button (click)="dtextSet()">Show change</button>
  </div>
  


// WEBPACK FOOTER //
// ./src/app/layout/doc-viewer/dt.component.ts.DtComponent.html